import { render } from "./mbm_page.vue?vue&type=template&id=2b08643f"
import script from "./mbm_page.vue?vue&type=script&lang=js"
export * from "./mbm_page.vue?vue&type=script&lang=js"

import "./mbm_page.vue?vue&type=style&index=0&id=2b08643f&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__